import React, {useEffect, useState} from 'react';
import Button  from '../../components/general/Button';
import ProgressBar  from '../../components/general/progress/ProgressBar'; 
import useStripe from '../../hooks/useStripe';
import useQuotas from '../../hooks/useQuotas';
import { useAuth } from "../../contexts/AuthContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/pro-duotone-svg-icons';
import {faCheck} from '@fortawesome/pro-solid-svg-icons';
import {faStar} from '@fortawesome/pro-solid-svg-icons';
import Skeleton from 'react-loading-skeleton';
import YalangoPremium from '../../assets/svg/yalango/YalangoPremium.svg';

const Premium = () => {
    const {createCheckoutSession, 
        getUserSubscriptions, 
        createStripePortalLink} = useStripe();

    const {getNumberOfTranslationsThisMonthFromCurrentUser, 
        getFreeQuotaLimits,
        getCurrentApiUsage} = useQuotas();
    let {currentUser, isPremium, checkIfPremiumUser} = useAuth();

    const [loading, setLoading] = useState(false);
    const [subscriptions, setSubscriptions] = useState(null);
    const [numberOfGoogleTranslations, setNumberOfGoogleTranslations] = useState(null);
    const [numberOfGoogleTranslationsLimit, setNumberOfGoogleTranslationsLimit] = useState(null);
    const [numberOfDecksUsed, setNumberOfDecksUsed] = useState(0);
    const [numberOfDecksLimit, setNumberOfDecksLimit] = useState(null);
    const [numberOfCardsUsed, setNumberOfCardsUsed] = useState(0);
    const [numberOfCardsLimit, setNumberOfCardsLimit] = useState(null);
    const [numberOfTablesUsed, setNumberOfTablesUsed] = useState(0);
    const [numberOfTablesLimit, setNumberOfTablesLimit] = useState(null);

    const createCheckoutSessionClick = async () => {
        setLoading(true);
        await createCheckoutSession();
    }
    useEffect(()=>{
        const fetchSubscriptionDetails = async () => {
            let r = await getUserSubscriptions();
            setSubscriptions(r);
            console.log(r);
        }

        const fetchTranslations = async () => {
            const [usage, monthly, limits] = await Promise.all([
                getCurrentApiUsage(),
                getNumberOfTranslationsThisMonthFromCurrentUser(),
                getFreeQuotaLimits(),
            ]);

            setNumberOfGoogleTranslations(monthly === null ? false : monthly);

            if (usage) {
                setNumberOfDecksUsed(typeof usage.number_of_decks === 'number' ? usage.number_of_decks : 0);
                setNumberOfCardsUsed(typeof usage.number_of_deck_cards === 'number' ? usage.number_of_deck_cards : 0);
                setNumberOfTablesUsed(typeof usage.number_of_tables === 'number' ? usage.number_of_tables : 0);
            } else {
                setNumberOfDecksUsed(0);
                setNumberOfCardsUsed(0);
                setNumberOfTablesUsed(0);
            }

            if (limits !== null){
                if (Object.prototype.hasOwnProperty.call(limits, 'numberOfGoogleTranslations')){
                    setNumberOfGoogleTranslationsLimit(limits['numberOfGoogleTranslations']);
                }
                if (Object.prototype.hasOwnProperty.call(limits, 'numberOfDecks')){
                    setNumberOfDecksLimit(limits['numberOfDecks']);
                }
                if (Object.prototype.hasOwnProperty.call(limits, 'numberOfCards')){
                    setNumberOfCardsLimit(limits['numberOfCards']);
                }
                if (Object.prototype.hasCardLimit){
                    setNumberOfTablesLimit(limits['numberOfTables']);
                } else if (Object.prototype.hasOwnProperty.call(limits, 'numberOfTables')) {
                    setNumberOfTablesLimit(limits['numberOfTables']);
                }
            }
        }

        const doEveryting = async () => {
            let r = await checkIfPremiumUser();
            console.log("Premium: ", r);
            if (r === true){
                await fetchSubscriptionDetails();
            }
            await fetchTranslations();
        }
        doEveryting(); 
    },[]);

    const goToCustomerPortalClick = async () => {
        setLoading(true);
        console.log("portal")
        await createStripePortalLink();
    }

    return (
        <>
            <div className="   text-sm ">    
                <div className="flex flex-col gap-8 p-2 sm:w-4/6 m-auto">
                        <div className="flex flex-row gap-4 justify-center place-items-center">
                           
                            <h1 className="font-bold">Plans on Yalango</h1>
                        </div>
                        {/* Current plan badge */}
                        <div className="flex justify-center">
                            {isPremium ? (
                                <div className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300">
                                    <FontAwesomeIcon icon={faCheck} /> Current plan: Premium
                                </div>
                            ) : (
                                <div className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300">
                                    <FontAwesomeIcon icon={faStar} /> Current plan: Basic
                                </div>
                            )}
                        </div>
                        {/* Subtle upgrade highlight (shown only on Basic) */}
                        {!isPremium && (
                            <div className="relative overflow-hidden rounded-xl border border-yellow-200 dark:border-yellow-700 bg-gradient-to-br from-yellow-50 to-amber-50 dark:from-yellow-900/20 dark:to-yellow-900/10 p-4 shadow-sm">
                                <div className="flex items-center gap-3 md:gap-4">
                                    <div className="shrink-0 w-10 h-10 rounded-full bg-white/80 dark:bg-yellow-800/40 flex items-center justify-center ring-1 ring-yellow-200 dark:ring-yellow-700">
                                        <img src={YalangoPremium} alt="Yalango Premium" className="w-6" />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="text-sm font-semibold text-yellow-900 dark:text-yellow-100 truncate">
                                            Yalango Premium removes usage limits
                                        </div>
                                        <div className="text-xs text-yellow-800/90 dark:text-yellow-200/90">
                                            and enables Text‑To‑Speech for your decks.
                                        </div>
                                    </div>
                                    <div className="mt-0 md:mt-0">
                                        <Button 
                                            onClick={createCheckoutSessionClick} 
                                            text={!loading ? "Upgrade" : <FontAwesomeIcon icon={faSpinner} className="fa-pulse" />} 
                                            color="green" 
                                            size="small"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white/70 dark:bg-gray-800/60 backdrop-blur p-5 shadow-sm">
                            <div className="mb-1 text-sm font-semibold text-gray-800 dark:text-gray-100">
                                Free plan usage status
                            </div>
                            <div className="mb-4 text-xs text-gray-500 dark:text-gray-400">
                                Upgrading to Premium removes these limits.
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                <div className="space-y-1">
                                    <div className="flex justify-between items-baseline text-xs text-gray-600 dark:text-gray-300">
                                        <span className="font-medium">Automatic translations this month</span>
                                        <span className="font-semibold tabular-nums text-gray-800 dark:text-gray-100">
                                            {(numberOfGoogleTranslations === false ? 0 : (numberOfGoogleTranslations?.number_of_translations ?? 0))}
                                            {numberOfGoogleTranslationsLimit !== null ? " / " + numberOfGoogleTranslationsLimit : ""}
                                        </span>
                                    </div>
                                    {numberOfGoogleTranslations !== null && numberOfGoogleTranslationsLimit !== null ? (
                                        <ProgressBar tooltipData="" text="" autoCalculate={true} progressNumber={numberOfGoogleTranslations === false ? 0 : numberOfGoogleTranslations.number_of_translations} progressGoal={numberOfGoogleTranslationsLimit} />
                                    ) : (
                                        <Skeleton height={14} count={1} />
                                    )}
                                </div>
                                <div className="space-y-1">
                                    <div className="flex justify-between items-baseline text-xs text-gray-600 dark:text-gray-300">
                                        <span className="font-medium">Total number of decks</span>
                                        <span className="font-semibold tabular-nums text-gray-800 dark:text-gray-100">{numberOfDecksUsed}{numberOfDecksLimit !== null ? " / " + numberOfDecksLimit : ""}</span>
                                    </div>
                                    {numberOfDecksLimit !== null ? (
                                        <ProgressBar tooltipData="" text="" autoCalculate={true} progressNumber={numberOfDecksUsed} progressGoal={numberOfDecksLimit} />
                                    ) : (
                                        <Skeleton height={14} count={1} />
                                    )}
                                </div>
                                <div className="space-y-1">
                                    <div className="flex justify-between items-baseline text-xs text-gray-600 dark:text-gray-300">
                                        <span className="font-medium">Total number of deck cards</span>
                                        <span className="font-semibold tabular-nums text-gray-800 dark:text-gray-100">{numberOfCardsUsed}{numberOfCardsLimit !== null ? " / " + numberOfCardsLimit : ""}</span>
                                    </div>
                                    {numberOfCardsLimit !== null ? (
                                        <ProgressBar tooltipData="" text="" autoCalculate={true} progressNumber={numberOfCardsUsed} progressGoal={numberOfCardsLimit} />
                                    ) : (
                                        <Skeleton height={14} count={1} />
                                    )}
                                </div>
                                <div className="space-y-1">
                                    <div className="flex justify-between items-baseline text-xs text-gray-600 dark:text-gray-300">
                                        <span className="font-medium">Total number of tables</span>
                                        <span className="font-semibold tabular-nums text-gray-800 dark:text-gray-100">{numberOfTablesUsed}{numberOfTablesLimit !== null ? " / " + numberOfTablesLimit : ""}</span>
                                    </div>
                                    {numberOfTablesLimit !== null ? (
                                        <ProgressBar tooltipData="" text="" autoCalculate={true} progressNumber={numberOfTablesUsed} progressGoal={numberOfTablesLimit} />
                                    ) : (
                                        <Skeleton height={14} count={1} />
                                    )}
                                </div>
                            </div>
                        </div>
                        {isPremium ? (
                            <>
                                <div className="flex flex-col gap-4 place-items-center">
                                    {subscriptions !== null && subscriptions.map((subscription,i)=>(
                                        <div className="md:w-4/6 m-auto w-full flex flex-col gap-4" key={"sub_"+i}>
                                            <h3 className="w-full">Subscription details</h3>
                                            <div className="text-left">
                                                You currently have an active subscription to Yalango Premium.
                                            </div>
                                            <div className="flex flex-row gap-2 justify-between">
                                                <div className="text-gray-600 font-bold">
                                                    Subscription started
                                                </div>
                                                <div>
                                                    {subscription.created.toDate().toDateString()}
                                                </div>
                                            </div>
                                            <div className="flex flex-row gap-6 justify-between">
                                                <div className="text-gray-600 font-bold">
                                                    Price per month
                                                </div>
                                                <div>
                                                    ${subscription.items[0].plan.amount/100} {subscription.items[0].plan.currency} 
                                                </div>
                                            </div>
                                            <div className="flex flex-row gap-6 justify-between">
                                                <div className="text-gray-600 font-bold">
                                                    Next payment
                                                </div>
                                                <div>
                                                    {subscription.current_period_end.toDate().toDateString()}
                                                </div>
                                            </div>
                                            <div className="text-center flex flex-row justify-center">
                                                <Button onClick={goToCustomerPortalClick} color="green" text={!loading ? "Manage subscription" : <FontAwesomeIcon icon={faSpinner} className="fa-pulse" />} />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <>

                            </>
                        )}
                </div>
            </div>
        </>
    )
}

export default Premium;